var render = function render(){var _vm=this,_c=_vm._self._c;return _c('w-icon-wrapper',{attrs:{"height":20,"width":20,"icon-name":"work-radio-unselected-icon","view-box":"0 0 20 20"}},[_c('circle',{attrs:{"id":"Radio_Button_Unselected","cx":"10","cy":"10","data-name":"Radio Button Unselected","fill":"currentColor","r":"10"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }